import { LegendSegmentWithCheckboxAndFavicon } from "@similarweb/ui-components";

export const SegmentLegendsWithFaviconAndCheckbox = (props) => (
    <LegendSegmentWithCheckboxAndFavicon
        {...props}
        withSegmentSign={true}
    />
);
